import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from "../../../utils/constant";
import axios from "axios";

export const getNotificationSliceContent = createAsyncThunk('/notifications/content', async () => {
    var userData=JSON.parse(localStorage.getItem("userData"));
	const response = await axios.post(`${API_URL}/getNotifications`, {});
	return response;
})

export const notificationSlice = createSlice({
    name: 'notifications',
    initialState: {
        isLoading: false,
        notifications : []
    },
    reducers: {
    },
    extraReducers: {
		[getNotificationSliceContent.pending]: state => {
			state.isLoading = true
		},
		[getNotificationSliceContent.fulfilled]: (state, action) => {
			state.notifications = action.payload.data
			state.isLoading = false
		},
		[getNotificationSliceContent.rejected]: state => {
			state.isLoading = false
		},
    }
})

export default notificationSlice.reducer